import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from 'swiper';
import { Pagination } from "swiper";
import SlideMen from '../slide/Slide'
import "swiper/css/pagination";
import SlideShow from '../slide/SlideShow'
import Reviews from '../reviews/Reviews'
import Services from '../services/Services'
import Footer from '../footer/footer'
import './menpage.scss'
import './swiper.css'
import "swiper/css";
const Screen = styled.div`
max-width: 1920px;
background: #d1bbff;
max-height: 500px;
height: 100%;
width:100%;
div{
  height: 400px;
  @media screen and (max-width:456px)
  {
    height: 311px;
  }
}

`
const Accessories = styled.div`
font-size: 1.4rem;
    font-weight: bold;
    z-index: 1;
    position: absolute;
    margin: 0 0.3rem;
    color:white;
    text-align: center;
    top: 0;
`
const TextArea = styled.div`
flex: 1;
background: linear-gradient(94.23deg, #87ACBC 4.4%, #D1BBFF 97.41%);
div {
  top: 15%;
  position: relative;
  width: 80%;
  transform: translate(50px, 0px);
  color: white;
  h1{
    font-size: 3rem;
    letter-spacing: 10px;
  }
  p{
    font-size: 25px;
    font-weight:100;
  }
  button{
    padding: 0.2rem 2.5rem;
    background: #ffffff;
    color: black;
    font-size: 20px;
    margin: 1rem 0;
    &:hover{
      background :#fdff9e;
      transition:.7s all ease-in-out;
    }
  }
}

`
const Grid = styled.div`
display:grid;
grid-template-columns: repeat(2, 1fr);
span{
  display: flex;
  font-size: 20px;
  align-items: center;
  cursor:pointer;
  width: fit-content;
  svg{
    margin:0 10px ;
  }
}
`

const Shoes = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    color:white;
    top: 15%;
`
const Hats = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    color: white;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 20%;
`
const Shampoos = styled.div`
    font-size: 1.8rem;
    font-weight: bold;
    z-index: 1;
    color: white;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    /* top: 5%; */
    color: black;
    height: inherit;
    align-items: center;
`
const Jackets = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    color: white;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 5%;
`

function MenPage(){
  SwiperCore.use([Autoplay]);
  return (
    <div className='w-full marqueee '>
    <div className='marque-container'>

        <div className='marquee '>
            <div>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
            </div>

        </div>
    </div>
        <div className='slide-screen'>
              <div className='flex slide-menu'>
                  <div className='  flex-test'>
                        <div className='slidee'>
                           {/* <Carousel autoplay  slides={slides}  /> */}
                           <Swiper

        direction={"vertical"}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
        autoplay
      >
  <SwiperSlide>
                           <Jackets className='flex'>
    J<br />A<br />C<br />K<br />E<br />T<br />S
  </Jackets>
 <StaticImage loading='eager'  src='../../images/jackets.jpg' className='w-full'/>
  </SwiperSlide>
  <SwiperSlide>
                           <Hats className='flex'>
    H<br />A<br />T<br />S<br />
  </Hats>
<StaticImage loading='eager' src='../../images/hat.jpg' className='w-full'/>
  </SwiperSlide>

  <SwiperSlide>
                           <Shoes className='flex'>
    S<br />H<br />O<br />E<br />S<br />
  </Shoes>
<StaticImage loading='eager' src='../../images/photo1.jpg' style={{height: 'inherit'}} className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Accessories className='flex'>
    A<br />C<br />C<br />E<br />S<br />S<br />O<br />R<br />I<br />E<br />S<br />
  </Accessories>
<StaticImage loading='eager' src='../../images/photo.jpg' style={{height: 'inherit'}} className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Shampoos className='flex'>
    S<br />A<br />M<br />P<br />O<br />O<br />S
  </Shampoos>
<StaticImage loading='eager' src='../../images/photo3.jpg' style={{height: 'inherit'}} className='w-full' />
  </SwiperSlide>
  </Swiper>
                      </div>
                  </div>
            <TextArea className='lumine-text'>
                <div>
                  <h1>LUMINE</h1>
                      <p>
                    Discover what suits you with Lumine.
                    Your unique style and fashion is waiting for you.
                      </p>
                <button>SHOP NOW</button>
              </div>
            </TextArea>
        </div>
        </div>
        <main>
          <div className='text-center  mt-16'>
          <h1 className='text-l'>Make your own fashion</h1>
          <p className='font-thin text-p'>Lumine is an E-commerce website,it only purpose is<br/> to provide a unique style for your very fashion.<br/>Start glowing with Lumine.</p>
            </div>
            <SlideMen/>
            <div className='mt-16'>
            <SlideShow />
            </div>
            <div className='mt-16 text-center'>
<h1 className='text-l'>Best sells & New Products</h1>
<p className='text-p font-thin'>Discover new items,products and more with LUMINE !<br/>Glow up with LUMINE.</p>
            </div>
            <div className='items mt-16'>
            </div>
{/* Quote1 */}
<Screen className=' text-center mt-16'>
  <Grid>
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>
<div className='bg'>
  </div>
</Grid>
</Screen>
{/*Quote 2 */}    
<Screen className='qt-2 text-center border-t-2 border-black'>
  <Grid>
  <div className='bg-1'>
  </div>
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>

</Grid>
</Screen>
{/*Quote 3 */}    
<Screen className='qt-3 text-center border-t-2 border-black'>
  <Grid>
 
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>
<div className='bg-3'>
  </div>
</Grid>
</Screen>
<div className='w-full marqueee2 '>
    <div className='marque-container2'>

        <div className='marquee2 '>
            <div>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
            </div>

        </div>
    </div>
    </div>
    <Reviews />
    <div>
      <h1 className='text-center text-three uppercase'>
        Services provided for you 
      </h1>
    <Services />
    </div>
        </main>
        <Footer />
</div>
  )
}

export default MenPage
